import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import styled from "styled-components";


const EditLevelSectionSidebarWrapper = styled.div`
  width: 300px;
  background-color: var(--sidebar-bg);
  border: 1px solid var(--sidebar-border-color);
  box-sizing: content-box;
  margin-left: -20px;
  margin-top: -40px;
  z-index: 1;

  height: auto;
  position:sticky;
`;

const EditLevelSectionSidebarInnerWrapper = styled.div`
  width: 300px;
  overflow: hidden auto;
  height: 100vh;
  padding: 20px 16px 8px 16px;
  display: flex;
  flex-direction: column;
  position: fixed;
`;

const EditLevelSectionSidebarItems = styled.div`
  margin-top: 20px;
`;

const EditLevelSectionSidebarItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  padding: 13px 5px 13px 10px;
  border-radius: 8px;
  cursor: pointer;

  &.active {
    background-color: var(--sidebar-active-item-bg);
  }

  &.active  * {
    color: var(--sidebar-active-item-color) !important;
  }

  &:hover:not(.active) {
    background-color: var(--sidebar-active-item-bg);
  }
`;

const EditLevelSectionSidebarItemText = styled.span`
  font-size: 16px;
  font-weight: 300;
  color: var(--sidebar-item-color);
  padding-left: 10px;
`;

const EditLevelSectionSidebarItemIcon = styled(Icon)`
  font-size: 18px;
  color: var(--sidebar-item-color);
`;

export const EditLevelSectionSidebar = ({
  show = true,
  courseLevel = null,
  defaultSelectedTab = window.location.hash ? window.location.hash.substr(1) : "details",
  onNavItemClicked = () => { },
  onToggle = () => { },
}) => {
  console.log("!!! DEFAULT SELECTED TAB: ", defaultSelectedTab)
  const [selectedTab, setSelectedTab] = useState(defaultSelectedTab);

  useEffect(() => {
    console.log("!!! DEFAULT SELECTED TAB CHANGED: ", defaultSelectedTab)
    setSelectedTab(defaultSelectedTab);
  }, [defaultSelectedTab]);

  useEffect(() => {
    window.history.pushState(null, null, `#${selectedTab}`);
    onNavItemClicked(selectedTab);

    // eslint-disable-next-line
  }, [selectedTab]);

  const selectTab = (tab) => {
    setSelectedTab(tab);
    // Update to use the has of the tab
  };

  const isSelected = (tab) => {
    console.log("!!! CHECKING IF SELECTED: ", tab, selectedTab, selectedTab === tab);
    return selectedTab.startsWith(tab) ? "active" : "";
  }


  return (
    <EditLevelSectionSidebarWrapper
      style={{
        width: show ? "300px" : "24px",
        transition: "width 0.3s ease-in-out",
        height: "100vh",
        marginTop: "-20px",
      }}
    >
      <button
        onClick={() => {
          onToggle();
        }}
        style={{
          width: "24px",
          height: "40px",
          backgroundColor: "var(--sidebar-active-item-bg)",
          color: "var(--sidebar-active-item-color)",
          borderTopRightRadius: ".25rem",
          borderBottomRightRadius: ".25rem",
          outline: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: "50%",
          right: "-24px",
          zIndex: 1,
          border: "none",
          cursor: "pointer",
          fontSize: "20px",
        }}
      >
        <i className="fas fa-ellipsis-v"></i>
      </button>
      <EditLevelSectionSidebarInnerWrapper
        style={{ display: show ? "flex" : "none" }}
      >
        <EditLevelSectionSidebarItems style={{ flexGrow: 0 }}>
          <EditLevelSectionSidebarItem className={isSelected("details")} onClick={() => selectTab("details")}>
            <span>
              <EditLevelSectionSidebarItemIcon icon="lucide:info" />
            </span>
            <EditLevelSectionSidebarItemText>Details</EditLevelSectionSidebarItemText>
          </EditLevelSectionSidebarItem>
          <EditLevelSectionSidebarItem className={isSelected("content")} onClick={() => selectTab("content")}>
            <span>
              <EditLevelSectionSidebarItemIcon icon="streamline-ultimate:book-book-pages" />
            </span>
            <EditLevelSectionSidebarItemText>Content</EditLevelSectionSidebarItemText>
          </EditLevelSectionSidebarItem>
          <EditLevelSectionSidebarItem className={isSelected("quiz")} onClick={() => selectTab("quiz")}>
            <span>
              <EditLevelSectionSidebarItemIcon icon="material-symbols:quiz-outline" />
            </span>
            <EditLevelSectionSidebarItemText>Quiz</EditLevelSectionSidebarItemText>
          </EditLevelSectionSidebarItem>
          <EditLevelSectionSidebarItem className={isSelected("faq")} onClick={() => selectTab("faq")}>
            <span>
              <EditLevelSectionSidebarItemIcon icon="qlementine-icons:faq-16" />
            </span>
            <EditLevelSectionSidebarItemText>FAQ</EditLevelSectionSidebarItemText>
          </EditLevelSectionSidebarItem>
          <EditLevelSectionSidebarItem className={isSelected("scripts")} onClick={() => selectTab("scripts")}>
            <span>
              <EditLevelSectionSidebarItemIcon icon="mdi:talking" />
            </span>
            <EditLevelSectionSidebarItemText>Scripts</EditLevelSectionSidebarItemText>
          </EditLevelSectionSidebarItem>
          <EditLevelSectionSidebarItem className={isSelected("tips")} onClick={() => selectTab("tips")}>
            <span>
              <EditLevelSectionSidebarItemIcon icon="icon-park-outline:tips" />
            </span>
            <EditLevelSectionSidebarItemText>Tips</EditLevelSectionSidebarItemText>
          </EditLevelSectionSidebarItem>
          <EditLevelSectionSidebarItem className={isSelected("practice")} onClick={() => selectTab("practice")}>
            <span>
              <EditLevelSectionSidebarItemIcon icon="iconoir:learning" />
            </span>
            <EditLevelSectionSidebarItemText>Practice</EditLevelSectionSidebarItemText>
          </EditLevelSectionSidebarItem>
          <EditLevelSectionSidebarItem className={isSelected("prompts")} onClick={() => selectTab("prompts")}>
            <span>
              <EditLevelSectionSidebarItemIcon icon="material-symbols-light:chat-outline-rounded" />
            </span>
            <EditLevelSectionSidebarItemText>Prompts</EditLevelSectionSidebarItemText>
          </EditLevelSectionSidebarItem>
        </EditLevelSectionSidebarItems>
      </EditLevelSectionSidebarInnerWrapper>
    </EditLevelSectionSidebarWrapper>
  );
};

export default EditLevelSectionSidebar;
